import { Component, Input } from '@angular/core';
import { BaseComponent } from 'src/app/core/base/base.component';
import { GeneralDiagnosticViewModel } from 'src/app/model/general/diagnostic.view';
import { DIAGNOSTIC_CONSTANTS } from './diagnostic.constants';
import { GeneralConsultDiagnosticService } from './diagnostic.service';
import { map, tap } from 'rxjs';

@Component({
  selector: 'ms-consult-diagnostic',
  templateUrl: './diagnostic.component.html',
})
export class GeneralConsultDiagnosticComponent extends BaseComponent {
  readonly screen = DIAGNOSTIC_CONSTANTS;
  @Input() turn = -1;
  @Input() readonly = false;
  diagnostics: GeneralDiagnosticViewModel[] = [];
  toRemove: number[] = [];
  expandSection = true;

  constructor(protected service: GeneralConsultDiagnosticService) {
    super();
  }

  onInit = () => {
    this.subscriptions.push(
      this.service
        .loadDiagnostics(this.turn)
        .pipe(
          map((res) =>
            res.map((item) => ({
              ...item,
              cieHelp: {
                id: item.code,
                displayName: item.displayName,
                description: item.description,
              },
            }))
          )
        )
        .subscribe((diagnostics) => (this.diagnostics = diagnostics))
    );
    if (!this.readonly) {
      this.subscriptions.push(
        this.service.isSaving().subscribe((saving) => {
          if (saving) {
            this.subscriptions.push(
              this.service
                .save(this.turn, this.diagnostics, this.toRemove)
                .subscribe(this.saveResult)
            );
          }
        })
      );
    }
  };

  removeDiagnostic = (idx: number) => {
    if (this.diagnostics[idx].id) {
      this.toRemove.push(this.diagnostics[idx].id!);
    }
    this.diagnostics.splice(idx, 1);
  };

  addUpdateDiagnostic = (diagnostic: GeneralDiagnosticViewModel) => {
    if (diagnostic.id) {
      this.diagnostics.forEach((item, idx) => {
        if (item.id === diagnostic.id) {
          this.diagnostics[idx] = diagnostic;
        }
      });
    }
  };

  private saveResult = (diagnostics: GeneralDiagnosticViewModel[]) => {
    // this.diagnostics = diagnostics
    //   .filter(
    //     (diagnostic) =>
    //       !this.toRemove.find((removed) => removed === diagnostic.id)
    //   )
    //   .map(this.service.setDiagnosticInformation);
    this.toRemove = [];
  };
}
